<template>
  <v-row>
    <v-col class="pl-0 ml-n2">
      <v-autocomplete
        v-model="selectedItems"
        item-text="name"
        item-value="id"
        :items="items"
        label="Thématique"
        :menu-props="{ maxHeight: '400', zIndex: 13 }"
        multiple
        outlined
        dense
      ></v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ThematicFilter",
  data() {
    return {};
  },
  async created() {
    await this.$store.dispatch("audience/getAcpmThematicList");
  },
  computed: {
    items() {
      return this.$store.getters["audience/getAcpmThematicList"];
    },
    selectedItems: {
      get() {
        return this.$store.getters["audience/getAcpmThematics"];
      },
      set(ids) {
        this.$store.dispatch("audience/updateAcpmThematics", ids);
      },
    },
  },
};
</script>

<style scoped></style>
